import React, { useEffect } from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'

import { FormWrapper } from './FormWrapper/FormWrapper'
import { Hotline } from './Hotline/Hotline'
import { Info } from './Info/Info'
import { Quote } from './Quote/Quote'
import { Video } from './Video/Video'

export const Compliance: React.FC = () => {
  const { setHeaderWhite } = useWrapperContext()

  useEffect(() => {
    setHeaderWhite(true)
    return () => setHeaderWhite(false)
  })

  return (
    <div className="container">
      <Quote />
      <Video />
      <Info />
      <Hotline />
      <FormWrapper />
    </div>
  )
}
